export const orderConstants = {
    ORDER_LOADING: "order_loading",
    ORDER_LOADED: "order_loaded",
    ORDER_ERROR: "order_error",
    ORDER_ID_CANCELED: "e6a5a5da-ae4b-46d6-bfbc-6938c732e8f3",
    ORDER_ID_PAID: "cf196fc7-ff1e-41aa-ab27-bf280e842120",
    ORDER_ID_WAITING: "40bdb506-181d-47ed-8912-e3d2951dde78",
    ORDER_ID_CREATED: "258e049d-5103-49b7-ac73-e14d5c44f95f",
    // 579b6a2e-f98e-41d6-99a1-6ce3ab924d7e ???
}